<template>
  <div>
    <h4
        class="h4 m-t-0 m-b-2"
        selenium="portfolio-label">
      My Past Projects for <span class="text-capitalize">{{ occupation }}</span>
    </h4>
    <gallery v-if="photos.length" :files="photos"/>
    <div v-else>No Photos</div>
  </div>
</template>

<script>
export default {
  name: 'work-area-section',
  props: {
    photos: {
      type: Array,
      required: true,
    },
    occupation: {
      type: String,
      required: false,
    },
  },
};
</script>
